<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xsJOee/tc-custom/FC-9781528903585.jpg?1685204507779?1725650247771" alt="This image is the cover for the book In Search of Cameos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In Search of Cameos
      </h1>
      <p class="bookDescription body article font2">
        <p>We are all searching for something… for answers… for love… or God perhaps. (Many would say for happiness.) Or could it be for those precious unexpected moments when life hovers pain-free…life’s ‘cameos’? As for the enigmatic Giulia, her search to uncover family truths finds her caught between two colliding worlds, or maybe three or four. Where exactly does she fit in? Should she speak of what she discovers? She finds solace in the beauty of the natural world and in man’s highest creative achievements set against her own strict Catholic formation. But nature can also destroy… and not all of humankind sets out to make our time on Earth more bearable, more poetic. Each chapter… or ‘cameo’… tells a little story of its own, each slotted within the bigger picture of Giulia’s journey. She is not alone. She has the support of a dear friend and, whether she likes it or not, of an elusive man in the outer shadows of her existence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Delle Cave
      </h2>
      
      <p class="authorDescription body article">Susan Delle Cave lives in South West London with her husband and has five daughters, all of whom live close by. She speaks three languages and has taught various subjects in a range of schools. Her many interests include the opera and theatre, genealogy, Sudoku for relaxation and spending time with a growing number of grandchildren. She would have liked to become an archaeologist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?589fceca